// @ts-nocheck
import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getSDAPriceForChart, getTokenPriceForChart } from '../exchange.service';
import { replaceTimestamps } from '../../../utils/replaceTimestamps';
import { chartIntervals } from '../../../utils/constants';
import { Button } from '@airdao/ui-library';

type MarketChartProps = {
  tokenAddress: string | undefined,
  marketStart: number,
  fpaPrice: number | null,
  marketId: string;
  quotePrice: number | undefined;
  askingPrice: number;
}

const MarketChart = ({ tokenAddress = '', marketStart, fpaPrice, marketId, quotePrice, askingPrice }: MarketChartProps) => {
  const [marketPrices, setMarketPrices] = useState([]);
  const [bondPrices, setBondPrices] = useState([]);
  const [chartInterval, setChartInterval] = useState(chartIntervals[2].value);

  useEffect(() => {
    const dateFrom = chartInterval ? new Date().getTime() - chartInterval : marketStart;

    getTokenPriceForChart(tokenAddress, dateFrom, new Date().getTime())
      .then((res) => {
        const market = [];
        const bond = [];

        res.data.forEach((el) => {
          market.push([el.timestamp, el.price]);
          bond.push([el.timestamp, fpaPrice]);
        });
        if (fpaPrice) {
          setMarketPrices(market);
          setBondPrices(bond);
        } else {
          setMarketPrices(market)
        }
        return res.data
      }).then((market) => {
      if (!fpaPrice) {
        getSDAPriceForChart(marketId, dateFrom, new Date().getTime())
          .then(({data}) => {
            setBondPrices([
              ...replaceTimestamps(data, market).map((el) => [el.timestamp, quotePrice / el.price]),
              [market[market.length - 1].timestamp, askingPrice]
            ])
          });
      }
    });
  }, [chartInterval]);

  const options: Highcharts.Options = {
    title: {
      text: null
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: null,
      }
    },
    yAxis: {
      title: {
        text: null,
      },
      labels: {
        formatter: function () {
          return '$' + this.value;
        }
      }
    },
    tooltip: {
      shared: true,
      formatter: function () {
        let tooltipContent = `<b>${Highcharts.dateFormat('%A, %b %e, %Y', this.x)}</b><br/>`;
        this.points?.forEach((point: Highcharts.Point, index: number) => {
          tooltipContent += `<span style="color:${point.series?.color}">${point.series?.name}: </span>$${point.y.toFixed(4)}<br/>`;
          if (index === 1) {
            const firstSeriesValue = this.points[0].y;
            const secondSeriesValue = point.y;
            const discountPercentage = ((firstSeriesValue - secondSeriesValue) / firstSeriesValue) * 100;
            tooltipContent += `Discount: ${discountPercentage.toFixed(2)}%<br/>`;
          }
        });
        return tooltipContent;
      }
    },
    series: [
      {
        name: 'Market price',
        data: marketPrices,
      },
      {
        name: 'Bond price',
        data: bondPrices,
        cropThreshold: Infinity,
      },
    ],
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
      <div className="chart-intervals">
        {(fpaPrice ? chartIntervals : chartIntervals.slice(2)).map((el) => (
          <button
            key={el.value}
            className={`chart-interval ${chartInterval === el.value ? 'chart-interval_active' : ''}`}
            onClick={() => setChartInterval(el.value)}
          >
            {el.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MarketChart;
